import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AttendanceState {
  view: "view1" | "view2" | "view3" | "view4" | "view5" | "view6" | "view7";
  selectedAgenda: any;
  attendanceId: string;
}

const initialState: AttendanceState = {
  view: "view1",
  selectedAgenda: "",
  attendanceId: ""
};

const EventStateSlice = createSlice({
  name: "EventStateSlice",
  initialState,
  reducers: {
    setView(
      state,
      action: PayloadAction<
        "view1" | "view2" | "view3" | "view4" | "view5" | "view6" | "view7"
      >
    ) {
      state.view = action.payload;
    },
    setAgenda(state, action: PayloadAction<string>) {
      state.selectedAgenda = action.payload;
    },
    setAttendanceId(state, action: PayloadAction<string>) {
      state.attendanceId = action.payload;
    }
  }
});

export default EventStateSlice;

export const EventStateSliceActions = EventStateSlice.actions;
